import React, { useEffect, useState } from 'react'
// import LoadingModal from '../../LoadingModal'
import { getObtenerTodasOpcionesCirugia, postDataPDFLiquidarUnProcedimineto, postInformacionEmpresa, postListComplicacionesDescripcionQx, postPreciosPaqueteLiquidacionQx } from '../../../services/PaginaRuta'
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalConfirmarLiquidacionPaquete from './ModalConfirmarLiquidacionPaquete'
import ModalPDFPaqueteLiquidacion from './ModalPDFPaqueteLiquidacion'

const ModalProcedimientoPaqueteLiquidacion = ({setmodalOnPaqueteProcedimientos, item, setactualizarDataLiquidacion}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo')); 
    const [modalOnConfirmarLiquidacionPaquete, setmodalOnConfirmarLiquidacionPaquete]=useState(false)
    const [dataProcedimientos, setDataProcedimientos] = useState([])
    // const [loadingProcedimientosPrecios, setLoadingProcedimientosPrecios] = useState(true)
    // const [validarButtonDescargaPDF, setValidarButtonDescargaPDF] = useState(false)
    const [valorTotalProcedimientos, setValorTotalProcedimientos] = useState(0)
    const [loading, setLoading] = useState(true)   
    const [dataOpcionCirugia, setdataOpcionCirugia] = useState([])
    const [complicacionesDx, setcomplicacionesDx]=useState({
          DxCompl:'',
          DMNomb:''
        })
    const [informacionEmpresa,setinformacionEmpresa]=useState({
          EMPCOD: "",
          EmpNit: "",
          EmpRazSoc: "",
          MCDnom: "",
          MCDpto: "",
          T2_EMPCOD: "",
      
        })
    const [dataPDF, setdataPDF]=useState({
          CrgCnt0:"",
          CrgCod:"",
          CrgEst:"",
          EmpDsc:"",
          ForLiqCod:"",
          ForLiqDsc:"",
          ForLiqVlHn:"",
          ForLiqcar:"",
          HomProDsc:"",
          MECTope:"",
          MENNIT:"",
          MENOMB:"",
          MaeVlrFact:"",
          MaeVlrNoC:"",
          MaeVlrReg:"",
          MeCnsCnt:"",
          PTCntUvr:"",
          PTCodi:"",
          PTDesc: "",
          ProCirCod:"",
          ProCons:"",
          ProEmpCod:"",
          ProFec:"",
          ProFecF:"",
          ProHorF:"",
          ProHorI:"",
          ProMCDpto:"",
          ProSedQr:"",
          ProSit:"",
          TFCscP:"",
          TFcCodCam:"",
          TFcCodPab:"",
          TipHer:"",
          TrfCod:"",
          ViaCod:"",
          ViaIng:""
        }) 

    const handleCancelClick = () => {
      setmodalOnPaqueteProcedimientos(false)
    }

    useEffect(() => {
      const precios={
        'arrayProcedimientos' : item.Procedimientos,
        'PTCodi': item.PTCodi,
      }
      setLoading(false)
      postPreciosPaqueteLiquidacionQx(precios).then((res) => {        
        const arrayProcedimientos = res.data

        //calcular el precio total de los procedimientos
        const precioTotalProcedimiento = arrayProcedimientos.reduce((acumulador, { ValorBaseTarifa, ValorUnitario }) => {
          const baseTarifa = Number(ValorBaseTarifa);
          const valorUnitario = Number(ValorUnitario);
          return acumulador + (baseTarifa === 0 ? valorUnitario : baseTarifa);
        }, 0);
        setValorTotalProcedimientos(precioTotalProcedimiento)

        //array de los procedimientos
        const procedimientosQX = item.Procedimientos

        //agregar medicos
        // Recorremos el array 'arrayProcedimientos' y buscamos el objeto correspondiente en 'procedimientosQX'
        arrayProcedimientos.forEach(item => {
          // Buscamos el objeto en 'procedimientosQX' cuyo id coincida
          const encontrado = procedimientosQX.find(val => val.PRCODI.trim() === item.CodigoProcedimiento.trim());
          if (encontrado) {
            // Asignamos el valor a una nueva propiedad, por ejemplo, precioTotalProcedimiento
            item.MedCod = encontrado.MedCod;
            item.EspcCod = encontrado.EspcCod;
            item.CrgHnrCi = encontrado.CrgHnrCi;
          }
        });
                
        //se agregan los valores por defecto a los procedimientos
        const nuevoDatosProcedimientos = arrayProcedimientos.map((item)=>{return{...item,tipoHojaFact: 'F' , agrupadorProcedimiento:'INDV', orden:1, via:'1', especilidadCirujano:'1', opcion:"1", precioTotalProcedimiento:precioTotalProcedimiento, porcentaje:100, precioPorcentajeProcedimiento: item.ValorBaseTarifa === 0? item.ValorUnitario : item.ValorBaseTarifa }})
        console.log(nuevoDatosProcedimientos, ' setDataProcedimientos')
        setDataProcedimientos(nuevoDatosProcedimientos)
        // setDataProcedimientos(res.data.data)
        // setLoadingProcedimientosPrecios(false)
        setLoading(true)
      }
    )}, [])

    useEffect(() => {
      const datosEmpresa={
           "EMPCOD":usuarioInfo.Empresa,
           "MCDpto":usuarioInfo.Sede
          }
              console.log(datosEmpresa,'datos empresaa')
           postInformacionEmpresa(datosEmpresa).then((res)=>{ 
            console.log(res.data,'datos empresaa')
            if(res.data[0]){
              setinformacionEmpresa(res.data[0])
              console.log(res.data,'datos empresaa')
            }
          })
    },[])

    useEffect(() => {
      getObtenerTodasOpcionesCirugia().then((res)=>{ 
            console.log(res.data.data)
            setdataOpcionCirugia(res.data.data)
          })
    },[])

    useEffect(() => {
      const datosPacientePDF={
        TFCedu: item.MPCedu,
        TFTDoc: item.MPTDoc,
        TmCtvIng: item.ProCtvIn,
        ProEmpCod: item.ProEmpCod,
        MENNIT: item.ProEPS,
        ProMCDpto: item.ProMCDpto,
        ProCirCod: item.ProCirCod,
        CrgEst: 'S',
        MeCfcha1: item.ProFec,
        CodMed: item.ProPerSe1,
        ForLiqCod: '01',
        HnrCod: '01',
        //CodigoFormaLiquidacion: '01',
        NumContrato: item.ProEPS
      }
      postDataPDFLiquidarUnProcedimineto(datosPacientePDF).then((res)=>{ 
        console.log(res.data,'datos pdf')
        setdataPDF(res.data[0])
      })
    },[])

    useEffect(() => {
      const dxPrincipa={
        CodEmpCod: usuarioInfo.Empresa,
        CodMcdpto:usuarioInfo.Sede,
        CodCir: item.ProCirCod
      }
      postListComplicacionesDescripcionQx(dxPrincipa).then((res)=>{ 
              if(res.data[0]){
                console.log(res.data,'COMPLICACIONES')
                setcomplicacionesDx({
                  DxCompl:res.data[0].DxCompl,
                  DMNomb:res.data[0].DMNomb
                })
              }
            })
    },[])

    const handleOnChangeFacturableHojaGasto=(id,value, precioProcedimiento) => {
      let cambiosSelectTipo = dataProcedimientos.map((item)=>{
        if(item.CodigoProcedimiento === id){
          if(value === 'H'){
            //realizar una resta al precio total de los procedimientos            
            const precioTotalProcedimiento = parseInt(valorTotalProcedimientos) - parseInt(precioProcedimiento)
            setValorTotalProcedimientos(precioTotalProcedimiento)
          }else if(value === 'F'){
            //realizar una suma al precio total de los procedimientos 
            const precioTotalProcedimiento = parseInt(valorTotalProcedimientos) + parseInt(precioProcedimiento)
            setValorTotalProcedimientos(precioTotalProcedimiento)
          }
          //si el valor es diferente a H o F no se hace nada
          return {...item, tipoHojaFact:value }
        }
        return item
      })
      setDataProcedimientos(cambiosSelectTipo)
      console.log(cambiosSelectTipo, ' cambiosSelectTipo')
    }

    const handleSelectAgrupadorQX=(id,value) => {
      let cambiosSelectAgrupador = dataProcedimientos.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, agrupadorProcedimiento:value }
        }
        return item
      })
      setDataProcedimientos(cambiosSelectAgrupador)
      console.log(cambiosSelectAgrupador, ' cambiosSelectAgrupador')
    }

    const handleSelectChangeVia=(id,value) => {
      let cambiosSelectVia = dataProcedimientos.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, via:value }
        }
        return item
      })
      setDataProcedimientos(cambiosSelectVia)
      console.log(cambiosSelectVia, ' cambiosSelectVia')
    }

    const handleSelectChangeEspecialidadCirujano=(id,value) => {
      let cambiosSelectEspecialidadCirujano = dataProcedimientos.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, especilidadCirujano:value }
        }
        return item
      })
      setDataProcedimientos(cambiosSelectEspecialidadCirujano)
      console.log(cambiosSelectEspecialidadCirujano, ' cambiosSelectEspecialidadCirujano')
    }

    const handleSelectChangeOpcion=(id,value) => {
      let cambiosSelectOpcion = dataProcedimientos.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, opcion:value }
        }
        return item
      })
      setDataProcedimientos(cambiosSelectOpcion)
      console.log(cambiosSelectOpcion, ' cambiosSelectOpcion')
    }

    const handleClickGuardarLiquidacion=()=>{
      setmodalOnConfirmarLiquidacionPaquete(true)
    }

    const valorPocentajeProcedimiento=(id, precio ,porcentaje)=>{      
      // calcular el precio con el porcentaje
      let precioProcedimientoConPorcentaje = dataProcedimientos.map((item)=>{
        if(item.CodigoProcedimiento === id){
          return {...item, precioPorcentajeProcedimiento:(parseInt(precio) * parseInt(porcentaje)) / 100, porcentaje:porcentaje}
        }
        return item
      })      
      setDataProcedimientos(precioProcedimientoConPorcentaje)

      //precio total de los procedimientos solo los que son facturables
      const totalPrecioProcedimiento = precioProcedimientoConPorcentaje.reduce((acc, item) => {
        if(item.tipoHojaFact === 'F') {
          return acc + parseInt(item.precioPorcentajeProcedimiento)
        }
        return 0;
      }, 0);
      setValorTotalProcedimientos(totalPrecioProcedimiento)
      console.log(totalPrecioProcedimiento, ' totalPrecioProcedimiento')
    }

    //colocar puntos a los precios ejemplo 1.000.000
  const formatearNumeroConPuntos=(numero)=> {
    if (numero === undefined || numero === null) {
      //console.error('Número no definido:', numero);
      return "0";  // o cualquier valor por defecto que desees
  }
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)]   mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md  bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Liquidación de los procedimiento Cirugía
            </h5>
            <button
              type="button"
              onClick={handleCancelClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
         
            <div className="flex-auto overflow-y-auto relative p-1">
             
              <div className="flex-auto overflow-y-auto relative p-1">     
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo Documento
                    </label>
                    <input
                      defaultValue={item.MPTDoc}                      
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.MPCedu}                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.MPNOMC}                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Codigo
                    </label>
                    <input
                      defaultValue={item.ProCirCod}                      
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Contrato
                    </label>
                    <input
                      disabled={true}
                      //defaultValue={nombreIdContrato}                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.ProFec?item.ProFec.split(' ')[0]:null}                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx Principal
                    </label>
                    <input                     
                      defaultValue={item.DiaSal}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-5">
                      
                    </label>
                    <input
                      disabled={true}                     
                      defaultValue={item.DMNomb}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx Complicación
                    </label>
                    <input
                      defaultValue={complicacionesDx.DxCompl}                      
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-5">
                      
                    </label>
                    <input
                      disabled={true}                      
                      defaultValue={complicacionesDx.DMNomb}                      
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row py-1  text-left">   
                </div>
            <div className="text-center bg-[#05a29d] pb-1">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
              >
                Procedimientos quirúrgicos
              </label>
            </div>

            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >                              
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Codigo Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tipo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >
                              Agrupador
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Via
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Esp.Ciru
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Opción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Porcentaje
                            </th>                            
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Valor
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripcion Tarifario
                            </th>
                          </tr>
                        </thead>

                        {
                          
                          dataProcedimientos.map((item)=>(
                            <tbody>
                              <tr className="divide-y divide-slate-700">
                                <td></td>
                              
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                 
                                  {item.CodigoProcedimiento}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                  
                                  {item.NombreProcedimiento}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select                                        
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.tipoHojaFact}                                        
                                        onChange={(e) => handleOnChangeFacturableHojaGasto(item.CodigoProcedimiento, e.target.value, item.precioPorcentajeProcedimiento)}
                                      >
                                        {/* <option value="seleccionar">-------------</option> */}
                                        <option value="F">Facturable</option>
                                        <option value="H">Hoja de Gasto</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                <select
                                        
                                        className="form-select block w-auto px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        //value={item.tipoHojaFact}
                                        value={item.agrupadorProcedimiento}
                                        onChange={(e) => handleSelectAgrupadorQX(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        
                                        <option value="BILA">Bilateral</option>
                                        <option value="INDV">Individual</option>
                                        <option value="MULT">Multiple</option>
                                      </select>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.via}
                                        onChange={(e)=>handleSelectChangeVia(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        {/* <option value="seleccionar">-------------</option> */}
                                        <option value="1">Unica via</option>
                                        <option value="2">Diferente via</option>
                                        <option value="3">Bilateral</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.especilidadCirujano}
                                        onChange={(e)=>handleSelectChangeEspecialidadCirujano(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        {/* <option value="seleccionar">-------------</option> */}
                                        <option value="1">Igual Especialidad</option>
                                        <option value="2">Diferente Especialidad</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">
                                  <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                      <select
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                                                border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        aria-label="Default select example"
                                        value={item.opcion}
                                        onChange={(e)=>handleSelectChangeOpcion(item.CodigoProcedimiento, e.target.value)}
                                      >
                                        {
                                          dataOpcionCirugia.map((item)=>(
                                            <option value={item.PrcMulOpc} key={item.PrcMulOpc}>{item.PrcMulDsc}</option>
                                          ))
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 whitespace-pre-wrap">
                                  <div className="pt-2">
                                    <div className="mb-3 w-full">
                                      <input
                                        defaultValue={item.porcentaje}
                                        onChange={(e) => {
                                          const value = parseInt(e.target.value, 10);

                                          // Validar que esté dentro del rango
                                          if (value >= 1 && value <= 100) {
                                            valorPocentajeProcedimiento(
                                              item.CodigoProcedimiento,
                                              parseInt(item.ValorBaseTarifa) === 0
                                                ? item.ValorUnitario
                                                : item.ValorBaseTarifa,
                                              value
                                            );
                                          } else {
                                            // Si no está en el rango, lo vaciamos o lo limitamos
                                            e.target.value = "";
                                          }
                                        }}
                                        autoComplete="off"
                                        type="number"
                                        min={1}   // ✅ HTML valida que no se pueda escribir menos de 1
                                        max={100} // ✅ HTML valida que no se pueda escribir más de 100
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        id="exampleFormControlInput1"
                                        placeholder="1 - 100"
                                      />
                                    </div>
                                  </div>
                                </td>
                                
                                
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{formatearNumeroConPuntos(parseInt(item.ValorBaseTarifa) === 0? item.ValorUnitario : item.ValorBaseTarifa)}</td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">{item.DescripcionTarifario}</td>
                              </tr>
                              
                            </tbody>
                          ))
                          
                          
                        }
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
             <PDFDownloadLink document={<ModalPDFPaqueteLiquidacion informacionEmpresa={informacionEmpresa} dataUser={item} dataPDF={dataPDF} dataPreciosPDF={dataProcedimientos} totalPrecioProcedimiento={valorTotalProcedimientos}/>} fileName="PaqueteLiquidacionQXXXXXXXX.pdf">
              <button
                      type="button"
                      onClick={handleClickGuardarLiquidacion}
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Liquidar
                  </button>
             </PDFDownloadLink>
            </div>
              </div>
              
            </div>
        </div>
        {
            loading? null:
            
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
          }
      </div>
      
      {modalOnConfirmarLiquidacionPaquete && <ModalConfirmarLiquidacionPaquete arrayProcedimientos={dataProcedimientos} dataUser={item} dataPDF={dataPDF} complicacionesDx={complicacionesDx} setmodalOnConfirmarLiquidacionPaquete={setmodalOnConfirmarLiquidacionPaquete} setmodalOnPaqueteProcedimientos={setmodalOnPaqueteProcedimientos} setactualizarDataLiquidacion={setactualizarDataLiquidacion} dataPreciosPDF={dataProcedimientos} totalPrecioProcedimiento={valorTotalProcedimientos}/>}
    </div>
  )
}

export default ModalProcedimientoPaqueteLiquidacion